<template>
  <div class="mt-10 text-4xl font-bold w-3/4 mx-auto">

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getLesson } from '@/services/LessonService';

export default {
  data() {
    return {
      isStudent: true,
      lesson: {},
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
      dashboardPath: 'auth/dashboardPath',
    }),
  },

  created() {
    this.findUserType(this.$route.query.lesson);
  },

  methods: {
    findUserType(lessonId) {
      getLesson(lessonId).then(({ data }) => {
        this.lesson = data;
        if (this.user.teacher && data.teacher_id === this.user.teacher.id) {
          this.isStudent = false;
          this.$router.push(`${this.dashboardPath}/classrooms`);
          return;
        }
        this.$router.push(`/lesson-review?booking=${lessonId}`);
      });
    },
  },

};
</script>
